import React from 'react';

type Props = {
  title: string;
  details: Record<string, any>;
};

export function DebugPanel({ title, details }: Props) {
  const status = details?.job_status || 'unknown';
  const progress = Array.isArray(details?.job_progress) ? details.job_progress : [];
  let progressLabel = '';
  if (progress.length > 0) {
    const last = progress[progress.length - 1];
    if (typeof last === 'string') {
      progressLabel = last;
    } else if (last?.event) {
      progressLabel = last.event;
    } else {
      try { progressLabel = JSON.stringify(last); } catch { progressLabel = String(last); }
    }
  }
  const summary = `Status: ${status}${progressLabel ? ` | Progress: ${progressLabel}` : ''}`;

  return (
    <details className="bg-gray-50 border rounded p-3">
      <summary className="text-xs font-medium text-gray-700 cursor-pointer select-none">
        {title} — {summary}
      </summary>
      {details?.job_error && (
        <div className="mt-2 rounded border border-red-200 bg-red-50 px-2 py-1 text-xs text-red-700">
          <span className="font-medium">Error:</span> {details.job_error?.message || JSON.stringify(details.job_error)}
        </div>
      )}
      <pre className="mt-2 text-xs text-gray-600 whitespace-pre-wrap">
        {JSON.stringify(details, null, 2)}
      </pre>
    </details>
  );
}
